<template>
  <b-card :no-body="noBody">
    <slot v-if="!loading"/>
    <b-row v-else>
      <b-col cols="12">
        <b-skeleton-img no-aspect height="150px"></b-skeleton-img>
      </b-col>
      <b-col cols="12" class="mt-3">
        <b-skeleton animation="wave" width="80%" height="25px"></b-skeleton>
      </b-col>
      <b-col cols="12" class="mt-3">
        <b-skeleton animation="wave" width="40%"></b-skeleton>
        <b-skeleton animation="wave" width="70%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: "BaseCard",
  props: {
    loading: {
      Default: true,
      type: Boolean
    },
    noBody: {
      Default: false,
      type: Boolean
    }
  }
}
</script>

<style scoped>

</style>